export const splitCamelCase = (str?: string | null) => {
  if (!str) return '';

  return str
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2');
};
